export const PHOTOS = [
  '/imgs/photo_2026-01-05_22-43-27.jpg',
  '/imgs/photo_2026-01-05_22-43-41.jpg',
  '/imgs/photo_2026-01-05_22-43-47.jpg',
  '/imgs/photo_2026-01-05_22-43-52.jpg',
  '/imgs/photo_2026-01-05_22-43-58.jpg',
  '/imgs/photo_2026-01-05_22-44-02.jpg',
  '/imgs/photo_2026-01-05_22-44-07.jpg',
  '/imgs/photo_2026-01-05_22-44-11.jpg',
  '/imgs/photo_2026-01-05_22-44-15.jpg',
  '/imgs/photo_2026-01-05_22-44-19.jpg',
  '/imgs/photo_2026-01-05_22-44-23.jpg',
  '/imgs/photo_2026-01-05_22-44-27.jpg',
  '/imgs/photo_2026-01-05_22-44-30.jpg',
  '/imgs/photo_2026-01-05_22-44-35.jpg',
  '/imgs/photo_2026-01-05_22-44-38.jpg',
  '/imgs/photo_2026-01-05_22-44-42.jpg',
  '/imgs/photo_2026-01-05_22-44-46.jpg',
  '/imgs/photo_2026-01-05_22-44-49.jpg',
  '/imgs/photo_2026-01-05_22-44-53.jpg',
  '/imgs/photo_2026-01-05_22-44-57.jpg',
  '/imgs/photo_2026-01-05_22-45-01.jpg',
  '/imgs/photo_2026-01-05_22-45-04.jpg',
  '/imgs/photo_2026-01-05_22-45-08.jpg',
  '/imgs/photo_2026-01-05_22-45-12.jpg',
  '/imgs/photo_2026-01-05_22-45-16.jpg',
  '/imgs/photo_2026-01-05_22-45-19.jpg',
  '/imgs/photo_2026-01-05_22-45-23.jpg',
  '/imgs/photo_2026-01-05_22-45-27.jpg',
  '/imgs/photo_2026-01-05_22-45-32.jpg',
  '/imgs/photo_2026-01-05_22-45-36.jpg',
];

// UI adjustments: глобальные офсеты для отображаемых чисел
export const PARTICIPANT_OFFSET = 5443;
export const VOTES_OFFSET = 123250;

const MODEL_NAMES = ['Мария', 'Анна', 'Елена', 'Виктория', 'Алина', 'Дарья', 'Полина', 'Кристина', 'Софья'];
const ACTRESS_NAMES = ['Ольга', 'Наталья', 'Екатерина', 'Александра', 'Татьяна', 'Юлия', 'Ксения', 'Ирина', 'Вероника'];
const DANCER_NAMES = ['Анастасия', 'Диана', 'Валерия', 'Арина', 'Милана', 'Карина', 'Ева', 'Алиса', 'Маргарита'];

const MODEL_DESC = [
  'Голосуйте за профессиональную модель, которая выделяется внешними данными, подачей и потенциалом представлять Ростов на конкурсах.',
  'Модель с яркой внешностью и уникальным стилем. Участвует в показах ведущих дизайнеров.',
  'Талантливая модель с опытом работы в fashion-индустрии более 3 лет.',
  'Харизматичная модель, которая покоряет подиумы своей грацией и уверенностью.',
  'Восходящая звезда модельного бизнеса с множеством наград.',
  'Элегантная модель с безупречным вкусом и чувством стиля.',
  'Модель с международным опытом работы и участием в мировых показах.',
  'Профессиональная фотомодель с портфолио в глянцевых журналах.',
  'Амбициозная модель, стремящаяся к вершинам модельного бизнеса.',
];

const ACTRESS_DESC = [
  'Талантливая актриса с классическим образованием, снимавшаяся в нескольких короткометражных фильмах.',
  'Актриса театра и кино с ярким драматическим талантом.',
  'Молодая актриса, покорившая сердца зрителей своей естественностью.',
  'Харизматичная актриса с опытом работы в сериалах и рекламе.',
  'Актриса с уникальным амплуа и запоминающейся внешностью.',
  'Талантливая исполнительница, владеющая различными актёрскими техниками.',
  'Актриса с театральным образованием и богатым сценическим опытом.',
  'Восходящая звезда кино с номинациями на молодёжные премии.',
  'Многогранная актриса, способная перевоплощаться в любой образ.',
];

const DANCER_DESC = [
  'Профессиональная танцовщица с 10-летним опытом. Специализация — contemporary и современная хореография.',
  'Танцовщица балета с классическим образованием и участием в престижных постановках.',
  'Яркая танцовщица в стиле hip-hop и street dance.',
  'Грациозная танцовщица, мастер латиноамериканских танцев.',
  'Профессионал бальных танцев с множеством наград на соревнованиях.',
  'Танцовщица современного танца с уникальной пластикой.',
  'Хореограф и танцовщица, создающая авторские постановки.',
  'Танцовщица с опытом выступлений на международных фестивалях.',
  'Талантливая исполнительница народных и эстрадных танцев.',
];

const MODELS = Array.from({ length: 9 }, (_, i) => ({
  id: `model-${i + 1}`,
  name: MODEL_NAMES[i],
  age: 20 + (i % 8),
  nominationId: 'models',
  image: PHOTOS[i],
  description: MODEL_DESC[i],
  votes: 345 - i * 30 + Math.floor(Math.random() * 50),
}));

const ACTRESSES = Array.from({ length: 9 }, (_, i) => ({
  id: `actress-${i + 1}`,
  name: ACTRESS_NAMES[i],
  age: 20 + (i % 8),
  nominationId: 'actresses',
  image: PHOTOS[9 + i],
  description: ACTRESS_DESC[i],
  votes: 289 - i * 25 + Math.floor(Math.random() * 50),
}));

const DANCERS = Array.from({ length: 9 }, (_, i) => ({
  id: `dancer-${i + 1}`,
  name: DANCER_NAMES[i],
  age: 20 + (i % 8),
  nominationId: 'dancers',
  image: PHOTOS[18 + i],
  description: DANCER_DESC[i],
  votes: 312 - i * 28 + Math.floor(Math.random() * 50),
}));

export const MOCK_PARTICIPANTS = [...MODELS, ...ACTRESSES, ...DANCERS];
